export const textLanguageCopy = {
  en: {
    title: 'Text language',
    auto: 'Detect automatically',
    unknown: 'Not sure yet',
    detecting: 'Detecting…',
    suggested: '{{language}}?',
    detected: 'Auto · {{language}}',
    change: 'Text language: {{language}}. Change language',
    other: 'Other / unsure',
    autoDetail: 'Uses the text. Your app and device language are only a small hint.',
    unknownDetail: 'Keep this text without assigning a language.',
    unavailable: 'Choose language',
  },
  sk: {
    title: 'Jazyk textu',
    auto: 'Rozpoznať automaticky',
    unknown: 'Zatiaľ neurčený',
    detecting: 'Rozpoznávam…',
    suggested: '{{language}}?',
    detected: 'Auto · {{language}}',
    change: 'Jazyk textu: {{language}}. Zmeniť jazyk',
    other: 'Iný / neviem',
    autoDetail: 'Rozhoduje text. Jazyk aplikácie a zariadenia je len malou pomôckou.',
    unknownDetail: 'Uložiť text bez určenia jazyka.',
    unavailable: 'Vybrať jazyk',
  },
  cs: {
    title: 'Jazyk textu',
    auto: 'Rozpoznat automaticky',
    unknown: 'Zatím neurčený',
    detecting: 'Rozpoznávám…',
    suggested: '{{language}}?',
    detected: 'Auto · {{language}}',
    change: 'Jazyk textu: {{language}}. Změnit jazyk',
    other: 'Jiný / nevím',
    autoDetail: 'Rozhoduje text. Jazyk aplikace a zařízení je jen malou nápovědou.',
    unknownDetail: 'Uložit text bez určení jazyka.',
    unavailable: 'Vybrat jazyk',
  },
} as const;
